import React from 'react';
import cx from 'classnames';

interface BadgeProps
  extends Omit<
    React.DetailedHTMLProps<
      React.HTMLAttributes<HTMLSpanElement>,
      HTMLSpanElement
    >,
    'className'
  > {
  /**
   * The text of Badge to display
   */
  text: string;

  /**
   * The size of the Button
   */
  size: 'sm' | 'md' | 'lg';

  /**
   * The color code of the badge text
   */
  color?: string;

  /**
   * The background color code of the badge
   */
  bgColor?: string;

  /**
   * To add additional className
   */
  className?: string;
}

const Badge = ({
  text,
  color,
  bgColor,
  size,
  className,
  ...props
}: BadgeProps) => {
  return (
    <span
      {...props}
      className={cx('badge bg-[#BA9A1C] text-white', className && className, {
        [size]: !!size,
        'leading-4': !className?.includes('leading-'),
      })}
      style={{
        ...(color && { color: color }),
        ...(bgColor && { backgroundColor: bgColor }),
      }}
    >
      {text}
    </span>
  );
};

Badge.defaultProps = {
  size: 'md',
};

export default Badge;
